import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DeleteSmsCampaign as DeleteSmsCampaignMutation,
    GetSmsBroadcasts as GetSmsBroadcastsQuery,
    GetSmsBroadcastsVariables as GetSmsBroadcastsQueryVariables,
} from 'nutshell-graphql-types';

import DELETE_SMS_CAMPAIGN from '../mutations/delete-sms-campaign.graphql';
import GET_SMS_BROADCASTS from '../queries/get-sms-broadcasts.graphql';

export function useDeleteSmsCampaign(queryVariables: GetSmsBroadcastsQueryVariables): {
    deleteCampaign: (id: string) => Promise<any>;
    isDeleting: boolean;
    error: string | null | undefined;
} {
    const [deleteCampaign, {loading, error}] = useMutation<
        DeleteSmsCampaignMutation,
        Record<any, any>
    >(DELETE_SMS_CAMPAIGN);

    return {
        deleteCampaign: (id: string) =>
            deleteCampaign({
                variables: {input: {id}},
                update: (proxy, mutationResults) => {
                    const cacheResult: GetSmsBroadcastsQuery | null | undefined = proxy.readQuery({
                        query: GET_SMS_BROADCASTS,
                        variables: queryVariables,
                    });

                    const deletedBroadcast = mutationResults.data?.campaignDelete?.campaign;

                    if (!deletedBroadcast) return;

                    if (cacheResult) {
                        proxy.writeQuery({
                            query: GET_SMS_BROADCASTS,
                            variables: queryVariables,
                            data: {
                                smsBroadcasts: cacheResult.smsBroadcasts.filter(
                                    (broadcast) => broadcast.id !== deletedBroadcast.id
                                ),
                            },
                        });
                    }
                },
            }),
        isDeleting: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
